"use strict";
(self["webpackChunk"] = self["webpackChunk"] || []).push([[7859],{

/***/ 9974:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23216);

(function($) {
    'use strict';
    const $toggle = $('.js-filter-form-desktop-toggle-btn');
    const $toggleInput = $(`#${$toggle.attr('for')}`);
    $toggleInput.off('change').on('change', (e)=>{
        const data = $toggle.data();
        if (e.currentTarget.checked) {
            $toggle.find('span').html(data.openText);
            $toggle.removeClass('q-open');
        } else {
            $toggle.find('span').html(data.closeText);
            $toggle.addClass('q-open');
        }
    });
    $toggleInput.trigger('change');
})(window.jQuery);


/***/ }),

/***/ 43753:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37946);



/***/ }),

/***/ 54645:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64622);



/***/ }),

/***/ 47068:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34163);



/***/ }),

/***/ 19682:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

/* harmony import */ var utils_query_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48174);
/* harmony import */ var utils_event_manager__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69705);


class AutoFillByQueryString {
    static sanitizeKey(key) {
        return key.replace('[', '\\[').replace(']', '\\]');
    }
    static sanitizeValue(value) {
        return value.replace(/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g, '\\\\$&');
    }
    static fillInputs($form, key, value) {
        key = AutoFillByQueryString.sanitizeKey(key);
        const $input = window.jQuery(`[name="${key}"]`, $form).not('input[type="checkbox"], input[type="radio"], .q-select-input[data-ajax] input, [data-autofill="false"]');
        if (!$input.length) {
            return;
        }
        if ($input.is('select')) {
            $input.val(value);
            $input.find(`option[value="${AutoFillByQueryString.sanitizeValue(value)}"]`).prop('selected', true).trigger('change');
        } else {
            $input.val(value);
        }
        $input.trigger('change');
    }
    static fillCheckInputs($form, key, value) {
        key = AutoFillByQueryString.sanitizeKey(key);
        const apply = function(value) {
            window.jQuery(`[name="${key}"]`, $form).not('[data-autofill="false"]').each((i, el)=>{
                const $input = window.jQuery(el);
                if (($input.is(':checkbox') || $input.is(':radio')) && value === $input.val()) {
                    $input.prop('checked', true).attr('checked', true).trigger('change');
                }
            });
        };
        if (Array.isArray(value)) {
            window.jQuery(value).each((i, val)=>{
                apply(val);
            });
        } else {
            apply(value);
        }
    }
    static fillAjaxSelects($form, key, value) {
        key = AutoFillByQueryString.sanitizeKey(key);
        key = key.replace('\\[', '');
        key = key.replace('\\]', '');
        const $ajaxSelects = window.jQuery(`.q-select-input[data-ajax="true"][data-name="${key}"]:not([data-autofill="false"])`, $form);
        if ($ajaxSelects.length) {
            $ajaxSelects.each((i, select)=>{
                window.jQuery(select).qselect('setValue', value);
            });
        }
    }
}
(function($1) {
    'use strict';
    if (!$1.fn.autoFillByQueryString) {
        $1.fn.autoFillByQueryString = function(qs = null) {
            const $form = this;
            qs = $form.data('current-params') || qs;
            const data = utils_query_string__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getQueryStringData */ .Z.getQueryStringData(qs);
            Object.keys(data).forEach(function(key) {
                const value = data[key];
                AutoFillByQueryString.fillInputs($form, key, value);
                AutoFillByQueryString.fillCheckInputs($form, key, value);
                AutoFillByQueryString.fillAjaxSelects($form, key, value);
            });
            utils_event_manager__WEBPACK_IMPORTED_MODULE_0__/* .EventManager.publish */ .Q.publish('autofillByQueryString.applied', data);
            return $form;
        };
    }
})(window.jQuery);
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (AutoFillByQueryString)));


/***/ }),

/***/ 69705:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": () => (/* binding */ EventManager)
/* harmony export */ });
/* harmony import */ var pubsub_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82941);
/* harmony import */ var pubsub_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(pubsub_js__WEBPACK_IMPORTED_MODULE_0__);
// https://github.com/mroderick/PubSubJS

delete window.PubSub;
window.EventManager = (pubsub_js__WEBPACK_IMPORTED_MODULE_0___default());
const EventManager = window.EventManager;


/***/ }),

/***/ 65917:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39187);
/* harmony import */ var components_filter_form_desktop_toggle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9974);
/* harmony import */ var components_filter_form_footer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43753);
/* harmony import */ var components_filter_form_header__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54645);
/* harmony import */ var components_filter_form_toggle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47068);
/* harmony import */ var components_select__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86325);
/* harmony import */ var styles_components_input_groups_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3209);
/* harmony import */ var _options_track__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(89571);
/* harmony import */ var utils_query_string__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(48174);
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34449);
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash_omit__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var utils_event_manager__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69705);
/* harmony import */ var utils_media_query__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(28925);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}












class FilterForm {
    bindAll() {
        if (this.track) {
            this.bindFormTracker();
        }
        this.bindFilterFormActions();
        this.bindFilterFormActionButtons();
        this.bindFilterFormToggle();
        this.bindFilterFormToggleButton();
        this.bindSelects();
    }
    bindSelects() {
        window.jQuery('.q-select-input', this.$form).each((i, el)=>{
            window.jQuery(el).qselect();
        });
    }
    bindFilterFormActions() {
        this.$form.on('change', 'input:not([data-no-summary])', ()=>this.toggleFilterFormActionButtons());
        utils_event_manager__WEBPACK_IMPORTED_MODULE_9__/* .EventManager.subscribe */ .Q.subscribe('autofillByQueryString.applied', ()=>this.toggleFilterFormActionButtons());
        window.jQuery(document).on('filterFormToggle', ()=>this.toggleFilterFormToggle());
    }
    bindFilterFormActionButtons() {
        this.toggleFilterFormActionButtons();
        window.jQuery('.js-btn-clean', this.$form).on('click', ()=>{
            this.$form.clearForm();
            return false;
        });
    }
    bindFormTracker() {
        this.$form.on('submit', ()=>{
            const { filterName } = this.$form.data();
            const data = new _options_track__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z(this.$form).parse();
            if (!filterName || Object.keys(data).length === 0) {
                return;
            }
            const notHasFilterQuestions = filterName !== 'questions';
            UserTracker.emit('event', _extends({
                eventName: `${filterName} searched`,
                data
            }, notHasFilterQuestions && {
                except: [
                    'user'
                ]
            }));
        });
    }
    bindFilterFormToggle() {
        this.$toggle.on('change', ()=>{
            const checked = this.$toggle.is(':checked');
            if (checked) {
                window.jQuery('body').addClass('q-no-scroll');
            } else {
                window.jQuery('body').removeClass('q-no-scroll');
            }
        });
    }
    bindFilterFormToggleButton() {
        const $toggleButton = window.jQuery('.js-filter-form-toggle-btn');
        if ($toggleButton.length) {
            const text = this.areFiltersApplied() ? $toggleButton.data().activeText : $toggleButton.data().inactiveText;
            $toggleButton.find('span').html(text);
        }
        $toggleButton.on('click', ()=>window.jQuery('#filter-form-toggle').prop('checked', true));
    }
    areFiltersApplied() {
        const params = utils_query_string__WEBPACK_IMPORTED_MODULE_11__/* ["default"].getQueryStringData */ .Z.getQueryStringData();
        const isFormNotEmpty = !!Object.keys(lodash_omit__WEBPACK_IMPORTED_MODULE_8___default()(this.$form.serializeObject(), [
            'per_page'
        ])).length;
        const hasQueryParams = !!Object.keys(lodash_omit__WEBPACK_IMPORTED_MODULE_8___default()(params, [
            'sort',
            'per_page'
        ])).length;
        return !!(isFormNotEmpty || hasQueryParams);
    }
    toggleFilterFormActionButtons() {
        window.jQuery('.js-filter-form-actions button', this.$form).not('.js-always-display').each((i, button)=>window.jQuery(button).attr('disabled', !this.areFiltersApplied()));
        this.$form.find('.js-filter-button').attr('disabled', !this.areFiltersApplied());
    }
    toggleFilterFormToggle() {
        if (utils_media_query__WEBPACK_IMPORTED_MODULE_10__/* .MediaQuery.is */ .z.is('md')) {
            return;
        }
        this.$toggle.prop('checked', !this.$toggle.prop('checked')).trigger('change');
    }
    constructor($form, options){
        window.jQuery.event.special.filterFormToggle = {
            noBubble: false
        };
        this.$form = $form;
        this.track = options.track;
        this.$toggle = window.jQuery('.js-filter-form-toggle');
        this.bindAll();
    }
}
(function($1) {
    'use strict';
    if (!$1.fn.filterForm) {
        $1.fn.filterForm = function(options = {}) {
            const $form = $1(this);
            this.filterFormInstance = new FilterForm($form, options);
            return $form;
        };
    }
})(window.jQuery);


/***/ }),

/***/ 89571:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ FilterFormTracker)
/* harmony export */ });
/* harmony import */ var utils_form_data_parser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59045);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

class FilterFormTracker extends utils_form_data_parser__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z {
    parse() {
        return Object.keys(this.summary).reduce((prev, curr)=>{
            return _extends({}, prev, {
                [`Form Label: ${this.summary[curr].label}`]: this.summary[curr].display
            });
        }, {});
    }
    constructor($form){
        super($form);
        this.$inputs = window.jQuery(this.inputSelector, this.$form);
        this.$inputs.toArray().forEach((el)=>this.change(el, false));
    }
}



/***/ }),

/***/ 59045:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ FormDataParser)
/* harmony export */ });
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34449);
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_omit__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_uniq__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75211);
/* harmony import */ var lodash_uniq__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_uniq__WEBPACK_IMPORTED_MODULE_1__);


class FormDataParser {
    static _getDisplayText($elem) {
        const text = $elem.data('summary-display') || $elem.text() || $elem.val() || '';
        return text.toString().trim();
    }
    _getInputs() {
        this.$inputs = window.jQuery(this.inputSelector, this.$form);
    }
    _getDisplay($input) {
        const isSelect = $input.is('select');
        const isCheckbox = $input.is(':checkbox');
        const isRadio = $input.is(':radio');
        if (!isSelect && !isCheckbox && !isRadio) {
            return FormDataParser._getDisplayText($input);
        }
        if (isSelect) {
            return $input.find(':selected').toArray().map((option)=>FormDataParser._getDisplayText(window.jQuery(option)));
        }
        const display = this.$form.find(`[name="${$input.attr('name')}"]:checked`).toArray().map((input)=>FormDataParser._getDisplayText(window.jQuery(input)));
        return lodash_uniq__WEBPACK_IMPORTED_MODULE_1___default()(display);
    }
    _getCheckedInputsByName(name) {
        return window.jQuery(`[name="${name}"]:checked`, this.$form);
    }
    removeEmpty($input, render = true) {
        const name = $input.attr('name');
        const value = $input.val();
        const item = this.summary[name];
        const display = this._getDisplay($input);
        if (!item) {
            return;
        }
        if (item.isCheckable && item.isMultiple) {
            const index = item.value.indexOf(value.toString());
            if (index > -1) {
                this.summary[name].value.splice(index, 1);
                this.summary[name].display = display;
                if (!this.summary[name].value.length) {
                    this.summary = lodash_omit__WEBPACK_IMPORTED_MODULE_0___default()(this.summary, name);
                }
            }
        } else {
            this.summary = lodash_omit__WEBPACK_IMPORTED_MODULE_0___default()(this.summary, name);
        }
        if (render) {
            this.render();
        }
    }
    change(element, render = true) {
        const $input = window.jQuery(element);
        const isCheckable = $input.is(':checkbox') || $input.is(':radio');
        const isCheckbox = $input.is(':checkbox');
        const isRadio = $input.is(':radio');
        const name = $input.attr('name');
        const isEmpty = !$input.val() || $input.val().toString().length <= 0;
        const isMultiple = $input.attr('multiple') !== undefined || $input.is(':checkbox');
        const hasKey = !!this.summary[name];
        const display = this._getDisplay($input);
        if (!hasKey && (!isCheckable && isEmpty || isCheckable && !$input.is(':checked'))) {
            if (render) {
                this.render();
            }
            return;
        }
        if ($input.is('[type=text], [type=search], textarea') && $input.attr('minlength') && Number($input.val().trim().length) < Number($input.attr('minlength'))) {
            return;
        }
        if (hasKey && $input.is('[type=text], [type=search], textarea') && (!$input.val() || $input.val().trim() === '')) {
            return this.removeEmpty($input, render);
        }
        if (hasKey && isCheckbox && !$input.is(':checked')) {
            return this.removeEmpty($input, render);
        }
        if (hasKey && isRadio && !this._getCheckedInputsByName(name).length) {
            return this.removeEmpty($input, render);
        }
        let value = $input.val();
        if (isMultiple && isCheckable) {
            value = this._getCheckedInputsByName(name).toArray().map((x)=>x.value.toString());
            value = lodash_uniq__WEBPACK_IMPORTED_MODULE_1___default()(value);
        }
        this.summary[name] = {
            name: name,
            value: value,
            display: display,
            label: $input.data('summary-label'),
            isCheckable: isCheckable,
            isMultiple: isMultiple,
            isSelect: !!$input.is('select')
        };
        if (render) {
            this.render();
        }
    }
    constructor(formElement, options = {}){
        this.inputSelector = 'input:not([data-no-summary]), select:not([data-no-summary]), textarea:not([data-no-summary])';
        this.$form = window.jQuery(formElement);
        this.summary = {};
        this.options = options;
    }
}



/***/ }),

/***/ 55310:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

/* harmony import */ var utils_form_data_parser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59045);
/* harmony import */ var utils_event_manager__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69705);
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11686);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}



class FormDataSummary extends utils_form_data_parser__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z {
    _prepare() {
        const placeholderHtml = `<span class="q-placeholder">${this.placeholder}:</span>`;
        this.$target.append(placeholderHtml);
        this.$main = window.jQuery('<div class="q-main"></div>');
        this.$target.append(this.$main);
        this.$form.addClass('q-form-data-summary');
        this.$target.addClass('q-summary-tags');
    }
    _bindRemoveEvents() {
        if (!this.options.readonly) {
            this.$target.find('.js-summary-tag-remove').off('click.tag_remove').on('click.tag_remove', (e)=>{
                const name = window.jQuery(e.currentTarget).data('name');
                this.remove(name);
            });
            this.$target.find('.js-summary-value-remove').off('click.value_remove').on('click.value_remove', (e)=>{
                const $elem = window.jQuery(e.currentTarget);
                const name = $elem.data('name');
                const value = $elem.data('value');
                this.removeValue(name, value);
            });
        }
    }
    render() {
        const keys = Object.keys(this.summary);
        if (!keys.length) {
            this.$main.html('<span class="q-empty">Os seus filtros aparecerão aqui.</span>');
            utils_event_manager__WEBPACK_IMPORTED_MODULE_1__/* .EventManager.publish */ .Q.publish('formDataSummary.changed', {
                empty: true
            });
            return;
        }
        this.$main.html('');
        keys.forEach((name)=>{
            const item = this.summary[name];
            const $tag = this.buildTag(item);
            this.$main.append($tag);
        });
        utils_event_manager__WEBPACK_IMPORTED_MODULE_1__/* .EventManager.publish */ .Q.publish('formDataSummary.changed', {
            empty: false
        });
        this._bindRemoveEvents();
    }
    buildTag(item) {
        let value = '';
        if (item.isMultiple) {
            value = item.display.map((display, i)=>`<div class="q-value-item" data-value="${i}">${display} ${this.options.readonly ? '' : `<button type="button"
              class="q-btn-remove js-summary-value-remove"
              data-name="${item.name}"
              data-index="${i}"
              data-value="${item.value[i]}">
              <i class="q-icon q-icon-times-circle"></i>
            </button>`}
          </div>`).join('');
        } else {
            value = `<div class="q-single-value-item">${item.display}</div>`;
        }
        return window.jQuery(`
        <div class="q-summary-tag">
          <div class="q-heading">
            <span class="q-label">${item.label}</span>
            ${this.options.readonly ? '' : `<button type="button" class="q-btn-remove js-summary-tag-remove" data-name="${item.name}"><i class="q-icon q-icon-times-circle"></i></button>`}
          </div>
          <span class="q-value">${value}</span>
        </div>
      `);
    }
    remove(name) {
        const item = this.summary[name];
        if (item.isMultiple) {
            window.jQuery(item.value).each((i, value)=>{
                this.removeValue(item.name, value);
            });
        } else {
            this.removeValue(item.name, item.value);
        }
    }
    removeValue(name, value) {
        const item = this.summary[name];
        const $input = window.jQuery(`[name="${item.name}"]` + (item.isCheckable ? `[value="${value}"]` : ''));
        if ($input.is(':checkbox') || $input.is(':radio')) {
            $input.prop('checked', false);
        } else {
            $input.val('', true);
        }
        $input.trigger('change');
    }
    refresh() {
        const self = this;
        self.summary = {};
        self._getInputs();
        self.$inputs.toArray().forEach((el)=>self.change(el, false));
        self.render();
    }
    constructor(formElement, targetSelector, options){
        super(formElement, _extends({
            readonly: false
        }, options));
        this.$target = this.$form.find(targetSelector);
        this.placeholder = this.$target.data('placeholder');
        this._prepare();
        // First Load
        this.refresh();
        // Handle changes
        this.$form.on('change input', this.inputSelector, (e)=>this.change(e.currentTarget));
        window.jQuery('.q-select-input', this.$form).qselect('on', 'fetch', ()=>setTimeout(()=>this.refresh(), 300));
        this.$form[0].formDataSummary = this;
    }
}
(function($1) {
    'use strict';
    if (!$1.fn.formDataSummary) {
        $1.fn.formDataSummary = function(targetSelector, options = null) {
            const formElement = this;
            if (formElement.length > 0) {
                const instance = new FormDataSummary(formElement, targetSelector, options);
                return instance.$form;
            } else {
                return this;
            }
        };
    }
})(window.jQuery);


/***/ }),

/***/ 28925:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": () => (/* binding */ MediaQuery)
/* harmony export */ });
window.screenBreakpoints = {
    xs: 'screen and (max-width:768px)',
    sm: 'screen and (min-width:768px)',
    lt_sm: 'screen and (max-width:768px)',
    md: 'screen and (min-width:992px)',
    lt_md: 'screen and (max-width:992px)',
    lg: 'screen and (min-width:1200px)',
    lt_lg: 'screen and (max-width:1200px)',
    header_lg_breakpoint: 'screen and (min-width:1024px)',
    lt_header_lg_breakpoint: 'screen and (max-width:1024px)'
};
class MediaQuery {
    static match(query) {
        return window.matchMedia ? window.matchMedia(query).matches : true;
    }
    static is(size) {
        return MediaQuery.match(window.screenBreakpoints[size]);
    }
}
window.MediaQuery = MediaQuery;


/***/ }),

/***/ 48174:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ QueryString)
/* harmony export */ });
class QueryString {
    static getQueryStringData(qs = null) {
        const uriSearch = qs || location.search;
        let str = decodeURIComponent(uriSearch);
        if (typeof str !== 'string') return {};
        str = str.trim().replace(/^\?/, '');
        if (!str) return {};
        return str.trim().split('&').reduce(function(ret, param) {
            const parts = param.replace(/\+/g, ' ').split('=');
            let key = parts[0];
            let val = parts[1];
            val = val === undefined ? null : val;
            if (ret[key] && Array.isArray(ret[key])) {
                const index = ret[key].indexOf(val);
                if (index < 0) ret[key].push(val);
            } else {
                if (key.indexOf('[]') > -1) ret[key] = [
                    val
                ];
                else ret[key] = val;
            }
            return ret;
        }, {});
    }
    static parseQueryStringData(obj) {
        return window.jQuery.param(obj);
    }
}



/***/ })

}]);